import { useMemo } from 'react'
import { FormControl, FormLabel, HStack, Tag, TagCloseButton, TagLabel } from '@chakra-ui/react'
import { UseFormReturn } from 'react-hook-form'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import CustomFormAutoComplete from 'components/tools/CustomForm/commonComponents/CustomFormAutoComplete'
import { CUSTOM_FORM_FILE_EXTENSIONS } from './constants/customFormFileExtensions'

type ValidationsProps = {
  formMethods: UseFormReturn<CustomFormQuestion>
}

export default function ExtensionsValidator({ formMethods }: ValidationsProps) {
  const currentExtensions: string[] = formMethods.watch('validation.extensions') || []

  const availableExtensions = useMemo(() => {
    return CUSTOM_FORM_FILE_EXTENSIONS.filter((extension) => {
      return !currentExtensions.includes(extension)
    })
  }, [currentExtensions])

  const handleOnSelect = (value: string) => {
    formMethods.setValue('validation.extensions', [...currentExtensions, value])
  }

  const handleOnRemove = (removedValue: string) => {
    const updatedExtensions = currentExtensions.filter((extension) => extension !== removedValue)
    formMethods.setValue('validation.extensions', updatedExtensions)
  }

  return (
    <FormControl display="flex" flexDir="column" gap={2}>
      <FormLabel fontWeight="bold">Extensões permitidas</FormLabel>
      <CustomFormAutoComplete options={availableExtensions} onSelect={handleOnSelect} />

      <HStack flexWrap="wrap">
        {currentExtensions.map((extension) => (
          <Tag variant="filter-tags" colorScheme="primary" key={extension}>
            <TagLabel>{extension}</TagLabel>
            <TagCloseButton onClick={() => handleOnRemove(extension)} />
          </Tag>
        ))}
      </HStack>
    </FormControl>
  )
}
